import { Avatar } from 'antd';
import React from 'react';
import Moment from 'react-moment';
import styled, { css } from 'styled-components';
import ALinkNested from './ALinkNested';
import BtnLike from './BtnLike';
import 'moment/locale/ko';

export const DivHorizental = styled.div`
    display: flex;

    ${({ margin }) => margin && css`
        > * :not(:first-child) {
            margin-left: ${margin};
        }
    `}
`;

export const DivVertical = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px;
`;

export const renderMembers = (product) => {
    // return <Avatar />
    return product?.members?.filter(member => member._id != product.writer._id)
        .map((member, index) => {
            return <ALinkNested pathname='/profile' state={{ targetUser: member }} key={member._id}>
                <Avatar src={member.image} key={member._id} />
            </ALinkNested>;
        });
};

export function UserProfile({ user }) {
    return <ALinkNested style={{ width: '16%', overflow: 'hidden', minWidth: '52px' }}
        pathname='/profile' state={{ targetUser: user }}>
        <DivVertical>
            <Avatar src={user?.image} />
            <label style={{ wordBreak: 'keep-all', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user?.name}
            </label>
        </DivVertical>
    </ALinkNested>;
}

function ProductCard({ children, user, product, ellepsis, ...rest }) {
    return <DivHorizental style={{ ...rest?.style }} >
        <UserProfile user={user} />
        <DivVertical style={{ width: '100%', overflow: 'hidden' }}>
            <DivHorizental>
                {renderMembers(product)}
                <BtnLike target={product} />
            </DivHorizental>
            <h4 style={ellepsis && { height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {product?.title}
            </h4>
            <label style={ellepsis && { height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {!rest?.hide_description && product?.description?.replace(/<[^>]+>/g, '')}
            </label>
            {/* <Moment style={{ textAlign: 'right' }} fromNow>{product?.updatedAt}</Moment> */}
        </DivVertical>
    </DivHorizental>;
}

export default ProductCard;